/*
 * Stubbable functions for testing purposes
 */

function _getScrollPosition() {
  return window.scrollY;
}
function _getCanUseIntersectionObserver() {
  return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
export const scrollMonitorUtilsMocks = {
  getScrollPosition() {
    return _getScrollPosition();
  },
  getCanUseIntersectionObserver() {
    return _getCanUseIntersectionObserver();
  }
};
export function getScrollPosition(...args) {
  return scrollMonitorUtilsMocks.getScrollPosition(...args);
}
export function getCanUseIntersectionObserver(...args) {
  return scrollMonitorUtilsMocks.getCanUseIntersectionObserver(...args);
}